import { render } from "./Airlock.vue?vue&type=template&id=fa87cf8e"
import script from "./Airlock.vue?vue&type=script&lang=js"
export * from "./Airlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__